import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-none border border-brand-dark/10 dark:border-brand-light/10
        bg-transparent hover:bg-brand-dark/5 dark:hover:bg-brand-light/5
        transition-all duration-300 ${className}`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <Moon className="w-5 h-5 text-brand-dark" strokeWidth={1.5} />
      ) : (
        <Sun className="w-5 h-5 text-brand-light" strokeWidth={1.5} />
      )}
    </button>
  );
};

export default ThemeToggle;
